import * as yup from "yup";
import { BaseSchema } from "../../BaseSchema";

export const editClientSubAccValidation = () => {
  const schema = yup.object().shape({
    client_sub_acc_name: yup.string().label("This field").required(),
    accountAdmins: yup
      .array()
      .min(
        1,
        "Account Admin is mandatory. Please assign at least one Account Admin"
      ),
    client_acc_name: yup
      .object()
      .label("This field")
      .required("This field is required")
      .typeError("This field is required"),
    ...BaseSchema,
  });

  return { schema };
};
